<div class="label">
  <span>Select your bonus</span>
</div>
<cs-select
  [(value)]="selectedBonus"
  [options]="bonusList"
  [disabled]="bonusLoading || bonusList.length === 0"
  (valueChange)="changeBonus($event)"
></cs-select>

@if (rateVos) {
  <div class="msg">
    Minimum deposit required for this bonus is {{ rateVos.minDeposit | currencyValue: currentCurrency }}
    {{ currentCurrency }}
  </div>
}
